const EMPTY_AMOUNT = '0.00';

class QuotationAmounts {
  /**
   * Create an instance of QuotationAmounts.
   */
  constructor() {
  /**
   * @property {string} subtotal - The subtotal amount.
   */
    this.subtotal = EMPTY_AMOUNT;

    /**
   * @property {string} taxes - The taxes amount.
   */
    this.taxes = EMPTY_AMOUNT;

    /**
   * @property {string} total - The total amount.
   */
    this.total = EMPTY_AMOUNT;
  }
}

export default QuotationAmounts;
